import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCoin, faArrowUp, faArrowDown } from "@fortawesome/pro-light-svg-icons";
import WhiteBox from "../../../components/WhiteBox";
import { BoldTitle, FH, Text, Title } from "../../main-styles";
import { getSaldo, getExtrato } from "../../../api/orgadots";
import { Spinner } from "reactstrap";
import moment from "moment-timezone";
import { useNavigate } from "react-router";

function Extrato() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.authReducer);
  const [saldo, setSaldo] = useState(null);
  const [extrato, setExtrato] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    setLoading(true);
    try {
      const [saldoData, extratoData] = await Promise.all([
        getSaldo(user.id),
        getExtrato(user.id),
      ]);
      setSaldo(saldoData.saldo || 0);
      const items = Array.isArray(extratoData)
        ? extratoData
        : Array.isArray(extratoData?.rows)
        ? extratoData.rows
        : Array.isArray(extratoData?.extrato)
        ? extratoData.extrato
        : Array.isArray(extratoData?.data)
        ? extratoData.data
        : [];
      setExtrato(items);
    } catch (error) {
      console.error("Error loading OrgaDots data:", error);
    }
    setLoading(false);
  }

  if (loading) {
    return (
      <div style={{ padding: 20, textAlign: "center" }}>
        <Spinner />
      </div>
    );
  }

  return (
    <div style={{ marginTop: 20 }}>
      <Title onClick={() => navigate(-1)} style={{ cursor: "pointer" }}>
        Voltar
      </Title>

      <WhiteBox style={{ marginBottom: 20 }}>
        <FH style={{ justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <Text style={{ color: "#999", fontSize: 12 }}>Seu saldo OrgaDots</Text>
            <div
              style={{
                fontSize: 32,
                fontWeight: 700,
                color: theme.primary,
                display: "flex",
                alignItems: "center",
                gap: 10,
              }}
            >
              <FontAwesomeIcon icon={faCoin} />
              {parseFloat(saldo).toLocaleString("pt-BR", {
                minimumFractionDigits: 2,
              })}
            </div>
          </div>
        </FH>
      </WhiteBox>

      <WhiteBox>
        <BoldTitle>Extrato de Movimentações</BoldTitle>
        {extrato.length === 0 ? (
          <Text style={{ color: "#999", marginTop: 10 }}>
            Nenhuma movimentação encontrada.
          </Text>
        ) : (
          <table className="table table-sm" style={{ marginTop: 10 }}>
            <thead>
              <tr>
                <th>Data</th>
                <th>Tipo</th>
                <th>Origem</th>
                <th>Descrição</th>
                <th style={{ textAlign: "right" }}>Valor</th>
              </tr>
            </thead>
            <tbody>
              {extrato.map((item) => (
                <tr key={item.id}>
                  <td style={{ verticalAlign: "middle", fontSize: 13 }}>
                    {moment(item.created_at).format("DD/MM/YY HH:mm")}
                  </td>
                  <td style={{ verticalAlign: "middle" }}>
                    <span
                      style={{
                        color: item.tipo === "credito" ? "#00a751" : "#d32f2f",
                        fontWeight: 600,
                        fontSize: 13,
                        display: "flex",
                        alignItems: "center",
                        gap: 4,
                      }}
                    >
                      <FontAwesomeIcon
                        icon={item.tipo === "credito" ? faArrowUp : faArrowDown}
                      />
                      {item.tipo === "credito" ? "Crédito" : "Débito"}
                    </span>
                  </td>
                  <td style={{ verticalAlign: "middle", fontSize: 13 }}>
                    {item.origem === "calculo_mensal"
                      ? "Cálculo Mensal"
                      : item.origem === "manual"
                      ? "Manual"
                      : item.origem === "compra"
                      ? "Compra"
                      : item.origem}
                  </td>
                  <td style={{ verticalAlign: "middle", fontSize: 13 }}>
                    {item.descricao || "-"}
                  </td>
                  <td
                    style={{
                      verticalAlign: "middle",
                      textAlign: "right",
                      fontWeight: 600,
                      fontSize: 14,
                      color: item.tipo === "credito" ? "#00a751" : "#d32f2f",
                    }}
                  >
                    {item.tipo === "credito" ? "+" : "-"}
                    <FontAwesomeIcon
                      icon={faCoin}
                      style={{ marginRight: 4 }}
                    />
                    {parseFloat(item.valor).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                    })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </WhiteBox>
    </div>
  );
}

export default Extrato;
